import * as React from 'react';
import { styled } from '@linaria/react';
import dynamic from 'next/dynamic';

import Demo, {
  DemoToggleButtonGroupControl,
} from '@/components/Demo';
import Spinner from '@/components/Spinner';
import Space from '@/components/Space';

const ClientOnlySnippet = dynamic(
  () => import('@/components/CodeSnippet/ClientOnlySnippet'),
  {
    ssr: false,
    loading: () => <Spinner style={{ alignSelf: 'center' }} />,
  }
);

type Mode = 'z' | 'line';

const INITIAL_VALUES: { mode: Mode } = {
  mode: 'z',
};

function ClosePathDemo() {
  return (
    <Demo
      outputWrapper={null}
      initialValues={INITIAL_VALUES}
      customGrid={{ gridTemplateColumns: '1fr' }}
      controlPosition="top"
      controls={[
        <DemoToggleButtonGroupControl
          inline
          key="mode"
          id="mode"
          label="Command"
          options={[
            {
              value: 'z',
              label: 'Close Path (Z)',
              shortLabel: 'Z',
            },
            {
              value: 'l',
              label: 'Line (L)',
              shortLabel: 'L 4,4',
            },
          ]}
        />,
      ]}
    >
      {({ mode }) => {
        const code =
          mode === 'z'
            ? `\
<path
  d="
    M 4,4
    L 4,12
    L 12,12
    Z
  "
>`
            : `\
<path
  d="
    M 4,4
    L 4,12
    L 12,12
    L 4,4
  "
>
`;

        return (
          <Wrapper>
            <SnippetWrapper>
              <ClientOnlySnippet
                omitCopyButton
                lockedToColorMode="dark"
                code={code}
                lang="html"
              />
            </SnippetWrapper>
            <SvgWrapper>
              <Svg viewBox="0 0 16 16">
                <path
                  d={
                    mode === 'z'
                      ? `
                      M 4,4
                      L 4,12
                      L 12,12
                      Z`
                      : `
                      M 4,4
                      L 4,12
                      L 12,12
                      L 4,4
                    `
                  }
                />
              </Svg>
            </SvgWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  color: white;
  padding: 16px;
  border: 1px solid var(--color-gray-300);
  border-radius: 8px;
`;

const SnippetWrapper = styled.div`
  flex: 1;
  min-width: 210px;
  padding-top: 8px;
  background: hsl(210deg 30% 15%);
  border-radius: 4px;
`;

const SvgWrapper = styled.div`
  flex: 1;
  align-self: flex-start;
  min-width: 210px;
  max-width: 250px;
  border: 1px solid var(--color-gray-300);
  border-radius: 4px;
`;

const Svg = styled.svg`
  display: block;
  width: 100%;
  aspect-ratio: 1/1;
  fill: none;
  stroke: white;
  stroke-width: 1px;
`;

export default ClosePathDemo;
